module.exports = __webpack_public_path__ + "images/09-02@2x_86ebe66b.png";